document.addEventListener("DOMContentLoaded", function () {
  const siteNavItem = document.querySelectorAll('.site-nav-item');
  siteNavItem.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      const collectionImageChild = item.querySelector('.collection-image-child');
      const urlImageBefore = collectionImageChild.getAttribute('src');
      const imageReplace = collectionImageChild.parentElement.parentElement.parentElement.previousElementSibling.querySelector('a img')
      imageReplace.src = urlImageBefore
    });

    item.addEventListener('mouseleave', function () {
      const collectionImageChild = item.querySelector('.collection-image-child');
      const imageReplace = collectionImageChild.parentElement.parentElement.parentElement.previousElementSibling.querySelector('a img');
      imageReplace.src = imageReplace.getAttribute('data-src');
    });
  });
});














